"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AvatarStack = void 0;
const jsx_runtime_1 = require("react/jsx-runtime");
const styled_1 = __importDefault(require("@emotion/styled"));
const Avatar_1 = require("./Avatar");
const HoverCard_1 = require("./HoverCard");
const constants_1 = require("../constants");
const AVATAR_OVERLAP_PX = 8;
const Stack = styled_1.default.div({
    borderRadius: constants_1.theme.border.radius.normal,
    display: 'flex',
    paddingLeft: AVATAR_OVERLAP_PX,
    transition: `filter ${constants_1.theme.animation.transition}`,
});
const StyledAvatar = (0, styled_1.default)(Avatar_1.Avatar)({
    border: `2px solid ${constants_1.Color.WHITE}`,
    boxSizing: 'content-box',
    marginLeft: -AVATAR_OVERLAP_PX,
});
const AvatarStack = (props) => {
    const avatarStack = ((0, jsx_runtime_1.jsx)(Stack, { className: props.className, children: props.avatars.map((avatar, index) => ((0, jsx_runtime_1.jsx)(StyledAvatar, { ...avatar }, index))) }));
    return props.hoverCardContent ? ((0, jsx_runtime_1.jsx)(HoverCard_1.HoverCard, { trigger: avatarStack, children: props.hoverCardContent })) : (avatarStack);
};
exports.AvatarStack = AvatarStack;
